// extracted by mini-css-extract-plugin
var _1 = "ForgotPassword-module__form__U0iZx";
var _2 = "ForgotPassword-module__input__Whpwy";
var _3 = "ForgotPassword-module__password_input_wrapper__MaqCx";
var _4 = "ForgotPassword-module__showPassword_btn__fP2XO";
var _5 = "ForgotPassword-module__sign_in_Heading__Lxt9l";
var _6 = "ForgotPassword-module__submit_button__JXaf9";
var _7 = "ForgotPassword-module__terms_link__xncUX";
export { _1 as "form", _2 as "input", _3 as "password_input_wrapper", _4 as "showPassword_btn", _5 as "sign_in_Heading", _6 as "submit_button", _7 as "terms_link" }
